// middleware/HttpHandler.js

import AlertService from "../services/AlertService";

const storeKey = process.env.REACT_APP_USER_KEY;
const tokenKey = storeKey + "_tk";
const permissionKey = storeKey + "_per";

const handler = (err) => {
  // OFFLINE
  if (err?.message?.includes("Failed to fetch")) {
    const currentPath = window.location.hash || "#/";
    sessionStorage.setItem("intendedPath", currentPath);
    window.location.replace("#/offline");
    return;
  }

  const status = err?.status || err?.response?.status;

  if (!status) return;

 if (status === 401) {

  AlertService.clear();

  // Session cleanup
  sessionStorage.removeItem(storeKey);
  sessionStorage.removeItem(tokenKey);
  sessionStorage.removeItem(permissionKey);
  sessionStorage.removeItem("hasShownInitialLoader");
  sessionStorage.removeItem("vm_data");

  // Cyber Range cleanup
  localStorage.removeItem("running_lab_course");
  localStorage.removeItem("lab_end_time");
  localStorage.removeItem("lab_last_activity");
  localStorage.removeItem("vm_event");
  localStorage.removeItem("vm_tab_reloading");
  localStorage.removeItem("lab_force_shutdown");
  localStorage.removeItem("lastActivity");

  // Cross-tab logout sync
  localStorage.setItem(
    "cyberBay_logout_event",
    Date.now()
  );

  if (window.location.hash !== "#/login") {
    window.location.replace("#/login");
  }

  return;
}

  if (status === 404 || status === 500) {
    AlertService.error("Technical error. Please contact support.");
    return;
  }

  const redirectMap = {
    400: "/#400",
    403: "/#403",
    408: "/#408",
    429: "/#429",
    502: "/#502",
    503: "/#503",
    504: "/#504",
  };

  const redirectPath = redirectMap[status];
  if (redirectPath) {
    window.location.replace(redirectPath);
  }
};

export default handler;